/* eslint-disable implicit-arrow-linebreak */
import { tipoOperacionPedimento } from "../catalogos";

const IDENTIFICADOR_DESPERDICIO = "(DESP)";

export const homologaNumeroPedimento = ({ fechaPagoReal, seccion, patente, pedimento, isDesperdicio = false }) => {
    const anio = new moment(fechaPagoReal).format("YY");
    const seccionSlice = seccion.slice(0, 2);
    return [anio, seccionSlice, patente, pedimento]
        .join(" ")
        .concat(isDesperdicio ? ` ${IDENTIFICADOR_DESPERDICIO}` : "");
};

export const getTipoOperacionDescripcion = (claveTipoOperacion) =>
    tipoOperacionPedimento.find((itm) => itm.clave === claveTipoOperacion);
